export const CREATE_CLIENT = 'createClient';
export const FETCH_CLIENT_BY_ID = 'fetchClientById';
export const UPDATE_CLIENT = 'updateClient';
export const FETCH_ORGANIZATION_CLIENTS = 'fetchOrganizationClients';
